import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";
import { Info } from "lucide-react";
import React from "react";

const AccountsDashboardCommonHeader = ({
  title,
  tooltipContent,
  seeAllButtonText,
  onSeeAll,
  headerAction = null,
}) => {
  return (
    <div
      className={`flex w-full gap-2 ${
        headerAction
          ? "flex-col items-stretch"
          : "items-center justify-between"
      }`}
    >
      <div className="flex gap-1.5 items-center min-w-0">
        <h6 className="text-gray-800 dark:text-gray-100 text-[0.76rem] leading-5 font-semibold truncate">
          {title}
        </h6>
        <CustomCommonTooltip content={tooltipContent}>
          <Info
            size={13}
            strokeWidth={1.5}
            className="text-gray-400 dark:text-gray-500 cursor-pointer"
          />
        </CustomCommonTooltip>
      </div>
      <div
        className={`flex items-center gap-2 shrink-0 ${
          headerAction ? "w-full justify-between" : ""
        }`}
      >
        {headerAction}
        <SecondaryButton
          className="border-none bg-transparent p-1 shadow-none text-[0.69rem] font-normal text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          title={seeAllButtonText}
          onClick={onSeeAll}
          disabled={typeof onSeeAll !== "function"}
        />
      </div>
    </div>
  );
};

export default AccountsDashboardCommonHeader;
